import { render, staticRenderFns } from "./BindUserWechat.vue?vue&type=template&id=7dd4780a&"
import script from "./BindUserWechat.vue?vue&type=script&lang=js&"
export * from "./BindUserWechat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports